import { ClearOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, Input, InputNumber, Space } from 'antd'
import type { FormInstance } from 'antd/es/form'
import { FC } from 'react'
import Contractor from '../../../../components/form-items/contractor/contractor'
import MaterialTypes from '../../../../components/form-items/material-types/material-types'
import { outputDateFormat } from '../../../../constants/constants'

interface FilterFormProps {
    form: FormInstance
    onSearch: () => void
    onClear: () => void
}

const FilterForm: FC<FilterFormProps> = ({ form, onSearch, onClear }) => {
    return (
        <Form form={form} component={false} onFieldsChange={onSearch}>
            <Space wrap>
                <Form.Item name='shipmentId' noStyle>
                    <Input placeholder='№ отгрузки' allowClear style={{ width: 120 }} />
                </Form.Item>
                <Contractor name='client' noStyle />
                <Form.Item name='labelName' noStyle>
                    <Input placeholder='Наименование вида' allowClear />
                </Form.Item>
                <MaterialTypes name='materialType' noStyle rules={[]} />
                <Form.Item name='month' noStyle>
                    <DatePicker
                        allowClear
                        picker='month'
                        placeholder='Месяц'
                        format='MM.YYYY'
                        style={{ width: 100 }}
                    />
                </Form.Item>
                <Form.Item name='materialWidth' noStyle>
                    <InputNumber controls={false} placeholder='Ширина' style={{ width: 100 }} />
                </Form.Item>
                <Form.Item name='stampId' noStyle>
                    <Input allowClear placeholder='№ Штампа' style={{ width: 115 }} />
                </Form.Item>
                <Form.Item name='clientDeliveryDate' noStyle>
                    <DatePicker
                        allowClear
                        placeholder='Дата поставки'
                        format={outputDateFormat}
                    />
                </Form.Item>
                <Button icon={<ClearOutlined />} title='Сбросить фильтры' onClick={onClear}>
                    Сброс
                </Button>
            </Space>
        </Form>
    )
}

export default FilterForm
